import { useCallback, useState } from 'react';

// A wrapper for useState where the state is a Set
export const useSetState = <T>(initialValues?: T[]) => {
  const [set, setValues] = useState<Set<T>>(new Set(initialValues));

  const add = useCallback(
    (value: T) => {
      setValues(prev => new Set(prev).add(value));
    },
    [setValues]
  );
  const remove = useCallback(
    (value: T) => {
      setValues(prev => {
        const nextSet = new Set(prev);
        nextSet.delete(value);
        return nextSet;
      });
    },
    [setValues]
  );

  return {
    set,
    add,
    remove,
  };
};
